












import { BCard, BCardText } from "bootstrap-vue";
import messagePreview from "@/views/modules/engage/create/components/messagePreview.vue";
import { computed, defineComponent, PropType } from "@vue/composition-api";
import useMessageTemplates from "@/composables/useMessageTemplates";
import { TemplateInterface } from "@/interfaces/template.interface";

export default defineComponent({
    components: { messagePreview, BCard, BCardText },
    props: {
        template: {
            required: true,
            type: Object as PropType<TemplateInterface>,
        },
    },
    setup(props) {
        const { convertTemplateToMessageContent } = useMessageTemplates();

        const message = computed(() => convertTemplateToMessageContent(props.template));

        return {
            message,
        };
    },
});
